export enum HcmStatus {
  AVAILABLE = 'AVAILABLE',
  MAINTENANCE_MODE = 'MAINTENANCE_MODE',
  RESTRICTED_MODE = 'RESTRICTED_MODE',
  UPDATE_PENDING = 'UPDATE_PENDING',
}
